import i18nRouteMeta from '@/app-core/mixins/i18n/i18nRouteMeta'
import AccountSettingsModel from '@/app-core/api/models/account/AccountSettingsModel'
import formData from '@/app-core/mixins/form/formData'
import CustomerModel from '@/app-core/api/models/customer/CustomerModel'
import API from '@/app-core/api/Api'
import ConfirmPinDialog from '@/app-theme/components/common/ConfirmPinDialog.vue'
import DataEventService from '@/app-core/lib/services/event/DataEventService'
import DataEventEnum from '@/app-core/lib/services/enum/DataEventEnum'
import {clone} from '@/app-core/lib/utils/helper'
import VueTelInputVuetify from '@/app-theme/components/common/VueTelInputVuetify/VueTelInputVuetify.vue'
import {getRegionCodeForCountryCode} from 'awesome-phonenumber'
import authOtp from '@/app-core/mixins/auth/authOtp'
import OtpDialog from '@/app-theme/components/common/OtpDialog.vue'
import {isValidMobilePhone} from '@/app-core/api/validations/CustomValidator'
import {toLocaleUpperCase} from '@/app-core/lib/helpers'

export default {
  name      : 'AccountSettings',
  components: {
    OtpDialog,
    VueTelInputVuetify,
    ConfirmPinDialog
  },
  directives: {},
  mixins    : [i18nRouteMeta, formData, authOtp],
  props     : {},
  enums     : {},
  dataStore : {},
  dataModel : AccountSettingsModel,
  data() {
    return {
      confirmDialog: {
        visible: false,
        input  : '',
        button : {
          no : {title: this.$t('Common.Button.Cancel')},
          yes: {title: this.$t('Common.Button.Confirm')}
        },
        title   : '',
        subTitle: '',
        content : '',
        callback: () => {
        }
      }
    }
  },
  computed: {
    phoneNeedsOtpValidation() {
      const phoneChanged = String(this.model.Phone) !== String(this.model.PhoneOriginal) || String(this.model.PhonePrefix) !== String(this.model.PhoneOriginalPrefix)
      const phoneValid = isValidMobilePhone(this.model.Phone, this.model)
      return this.AppConfig?.Auth?.Otp?.Sms && phoneValid && (phoneChanged || !this.model.PhoneValidated)
    },

    hasPushNotificationsPermission() {
      return Notification.permission === 'granted'
    },

    pushNotificationsPermission() {
      return Notification.permission
    },

    pushMarketing: {
      get() {
        return this.hasPushNotificationsPermission ? this.model.Push : false
      },
      set(value) {
        this.model.Push = value
      }
    },

    pushSystem: {
      get() {
        return this.hasPushNotificationsPermission ? this.model.PushSystem : false
      },
      set(value) {
        this.model.PushSystem = value
      }
    }
  },
  watch: {},
  beforeCreate() {
  },
  created() {
    this.$bus.$on(DataEventEnum.EVENT, this.pushChangeSave)
  },
  beforeMount() {
  },
  mounted() {
  },
  beforeUpdate() {
  },
  updated() {
  },
  beforeDestroy() {
    this.$bus.$off(DataEventEnum.EVENT, this.pushChangeSave)
  },
  destroyed() {
  },
  methods: {
    toLocaleUpperCase,
    clone,
    getRegionCodeForCountryCode,
    async onPushChange(newVal) {
      if (newVal && this.pushNotificationsPermission === 'default') {
        const permission = await Notification.requestPermission()
        if (permission) this.$forceUpdate()
      }

      this.pushChangeSave()
    },

    pushChangeSave(data) {
      if (data) {
        if (data?.Event === DataEventEnum.PUSH_USER_SUBSCRIPTION_CHANGE) {
          try {
            this.model.SaveSettings(true)
          } catch (e) {
            // console.log(e)
          }
        }
      } else {
        try {
          this.model.SaveSettings(true)
        } catch (e) {
          // console.log(e)
        }
      }
    },

    onDeleteClick() {
      this.confirmDialog.action = 'DELETE'

      this.$root.$confirm.open(
        this.$t('Account.Settings.Notification.Delete.Title'),
        this.$t('Account.Settings.Notification.Delete.Subtitle'),
        this.$t('Account.Settings.Notification.Delete.Body'),
        {
          color        : 'info',
          icon         : 'mdi-alert',
          coloredBorder: false,
          dark         : true,
          button       : {
            no : {title: this.$t('Common.Button.Cancel')},
            yes: {title: this.$t('Common.Button.Ok')}
          }
        }
      ).then(response => {
        if (response) this.onConfirmGetPin()
      })
    },
    onConfirmDelete(pin) {
      const response = this.model.DeleteAccount({
        CustomerId: this.model.Id,
        PIN       : pin
      })

      this.handleApiResponse(response, true)
    },

    onExportClick() {
      this.confirmDialog.action = 'EXPORT'

      this.$root.$confirm.open(
        this.$t('Account.Settings.Notification.Export.Title'),
        this.$t('Account.Settings.Notification.Export.Subtitle'),
        this.$t('Account.Settings.Notification.Export.Body'),
        {
          color        : 'info',
          icon         : 'mdi-alert',
          coloredBorder: false,
          dark         : true,
          button       : {
            no : {title: this.$t('Common.Button.Cancel')},
            yes: {title: this.$t('Common.Button.Ok')}
          }
        }
      ).then(response => {
        if (response) this.onConfirmGetPin()
      })
    },
    onConfirmExport(pin) {
      const response = this.model.ExportAccount({
        CustomerId: this.model.Id,
        PIN       : pin
      })

      this.handleApiResponse(response)
    },

    handleApiResponse(result, logout = false) {
      result
        .then(response => {
          const data = API.responseData(response)
          if (API.isResponseSuccess(response)) {
            if (data.Messages.Success) {
              this.confirmDialog.visible = false
              this.$bus.$emit('app:show-notification', {
                title: '',
                body : data.Messages.Success,
                type : 'success',
                icon : ''
              })
              this.$bus.$emit('app:logout')
            } else if (data.Messages.Error) {
              this.$bus.$emit('app:show-notification', {
                title: '',
                body : data.Messages.Error,
                type : 'error',
                icon : ''
              })
            }
          } else {
            this.$bus.$emit('app:show-notification', {
              title: '',
              body : response.data.message,
              type : 'error',
              icon : ''
            })
          }
        })
        .catch(() => {
          this.$bus.$emit('app:show-notification', {
            title: '',
            body : this.$t('Common.Error.Generic'),
            type : 'error',
            icon : ''
          })
        })
        .finally(() => {
        })
    },

    onConfirmGetPin() {
      this.model.ConfirmPin({CustomerId: this.model.Id})
        .then(response => {
          const data = API.responseData(response)
          if (API.isResponseSuccess(response)) {
            if (data.Messages.Success) {
              if (this.confirmDialog.action === 'EXPORT') {
                this.confirmDialog = {
                  visible      : true,
                  color        : 'info',
                  icon         : 'mdi-alert',
                  coloredBorder: false,
                  dark         : true,
                  input        : this.$t('Account.Settings.Notification.Export.ConfirmPin.Title'),
                  button       : {
                    no : {title: this.$t('Common.Button.Cancel')},
                    yes: {title: this.$t('Common.Button.Confirm')}
                  },
                  title   : this.$t('Account.Settings.Notification.Export.ConfirmPin.Title'),
                  subTitle: this.$t('Account.Settings.Notification.Export.ConfirmPin.Subtitle'),
                  content : this.$t('Account.Settings.Notification.Export.ConfirmPin.Body'),
                  callback: this.onConfirmExport
                }
              } else if (this.confirmDialog.action === 'DELETE') {
                this.confirmDialog = {
                  visible      : true,
                  color        : 'info',
                  icon         : 'mdi-alert',
                  coloredBorder: false,
                  dark         : true,
                  input        : this.$t('Account.Settings.Notification.Export.Delete.Title'),
                  button       : {
                    no : {title: this.$t('Common.Button.Cancel')},
                    yes: {title: this.$t('Common.Button.Confirm')}
                  },
                  title   : this.$t('Account.Settings.Notification.Export.Delete.Title'),
                  subTitle: this.$t('Account.Settings.Notification.Export.Delete.Subtitle'),
                  content : this.$t('Account.Settings.Notification.Export.Delete.Body'),
                  callback: this.onConfirmDelete
                }
              }
            } else if (data.Messages.Error) {
              this.$bus.$emit('app:show-notification', {
                title: '',
                body : data.Messages.Error,
                type : 'error',
                icon : ''
              })
            }
          }
        })
        .catch(e => {

        })
    },

    onSaveClick() {
      if (!this.validateForm()) return

      if (this.phoneNeedsOtpValidation) {
        this.otpRequest()
      } else {
        this.saveFromData()
      }
    },

    saveFromData() {
      if (!this.validateForm() || this.isFormSaving) return
      if (typeof this.clearServerErrorMessages === 'function') this.clearServerErrorMessages()
      this.isFormSaving = true

      // this.model.PhoneValidated = false

      this.model.SaveSettings()
        .then(response => {
          this.handleFormSaveResponse(response)
        })
        .catch(error => {
          this.handleFormSaveResponse(error.response)
        })
        .finally(() => {
          this.isFormSaving = false
        })
    },

    formSaveSuccess(data) {
      this.showGenericError = false
      this.genericError = ''
      this.$emit('form:save:success', data)

      if (!data?.Messages?.Success || !data?.CustomerInfo) return

      this.user = new CustomerModel(data.CustomerInfo)
      this.model = new AccountSettingsModel(data.CustomerInfo.Info)

      this.$bus.$emit('app:show-notification', {
        body   : data.Messages.Success,
        type   : 'success',
        icon   : 'mdi-check-circle',
        timeout: 5000
      })

      DataEventService.Emit(DataEventEnum.EVENT, {
        Event  : DataEventEnum.ACCOUNT_UPDATE,
        Payload: clone(this.user)
      })
    }
  }
}
